import { create } from 'zustand';
import { Platform } from '~/screens/types';

type MarketerCreatorStore = {
  isAdvancedFiltersDrawerOpen: boolean;
  setIsAdvancedFiltersDrawerOpen: (isOpen: boolean) => void;

  advancedFiltersActivePlatform: Platform;
  setAdvancedFiltersActivePlatform: (platform: Platform) => void;
};

export const useMarketerCreatorStore = create<MarketerCreatorStore>((set) => ({
  isAdvancedFiltersDrawerOpen: false,
  setIsAdvancedFiltersDrawerOpen: (isOpen) =>
    set(() => ({ isAdvancedFiltersDrawerOpen: isOpen })),

  advancedFiltersActivePlatform: 'Select Platform' as Platform,
  setAdvancedFiltersActivePlatform: (platform) =>
    set(() => ({ advancedFiltersActivePlatform: platform })),
}));
